// SUPPORTCFG: the ONE place the frontend learns the support address.
//
// WHAT THIS REMOVES. A personal address was hardcoded in two separate places (the connectivity
// overlay and the crash boundary), so every user who hit either error page was told to email one
// named individual, and that address shipped in the public JavaScript bundle for anyone to read.
//
// WHY BUILD TIME RATHER THAN AN API (confirmed decision). Both pages that need this address are
// shown precisely BECAUSE something is broken: the connectivity overlay appears when the backend is
// unreachable, and the crash boundary appears when the React tree has already failed. Fetching the
// address at that moment is the one thing that cannot be relied on, so it is injected at build time
// from REACT_APP_SUPPORT_EMAIL.
//
// WHEN IT IS NOT SET, NO CONTACT LINE IS SHOWN. An unset value is never substituted with a default
// address: shipping a fallback address is exactly what this change exists to remove. Callers test
// the value and omit their contact line entirely when it is empty.
//
// NO ADDRESS APPEARS IN THIS FILE, by design. A source guard asserts that.

/**
 * The configured support address, or an empty string when none is configured.
 * Never throws: a missing build-time variable must not break an error page.
 */
export function supportEmail() {
  try {
    return (process.env.REACT_APP_SUPPORT_EMAIL || '').trim();
  } catch {
    return '';
  }
}

/**
 * Warn once, at startup, when no support address is configured, naming the setting so an
 * unconfigured deployment is loud rather than silent. Silent during tests.
 */
export function warnIfSupportEmailMissing() {
  if (supportEmail() || process.env.NODE_ENV === 'test') return;
  // eslint-disable-next-line no-console
  console.warn(
    'REACT_APP_SUPPORT_EMAIL is not set. Error pages will show no contact address. '
    + 'Set it at build time (see docs/runbooks/contact-configuration.md).'
  );
}

export default supportEmail;
